<template>
  <div class="f-center aicons">
    <div
      :class="{ 'no-events opacity_4': noItems }"
      class="csst csst_nm icon_btn aicons_item mdi mdi-chevron-left"
      @click="go(-1)"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
    >
      <div
        class="csst_content"
        style="position: fixed"
        v-html="$t('tooltips.show_previous_hand_key', { key: '↑' })"
      ></div>
    </div>
    <div
      :class="{ 'no-events opacity_4': noItems }"
      class="csst csst_nm icon_btn aicons_item mdi mdi-chevron-right"
      @click="go(1)"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
    >
      <div
        class="csst_content"
        style="position: fixed"
        v-html="$t('tooltips.show_next_hand_key', { key: '↓' })"
      ></div>
    </div>

    <div
      v-if="hasStarBtn"
      class="csst csst_nm icon_btn aicons_item mdi mdi-star text-medium"
      style="font-size: 1.125rem"
      :style="handDetailItem.marked ? 'color:var(--clr-yellow)' : 'color: var(--clr-grey-2);'"
      :class="handDetailItem.marked ? 'mdi-star' : 'mdi-star-outline'"
      @click="toggleMarked(handDetailItem)"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
    >
      <div
        class="csst_content clr-white"
        style="position: fixed"
      >
        <span>{{ $t(`common.${handDetailItem.marked ? 'starred' : 'not_starred'}`) }} </span>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import tcrud_mix from '@/components/DataTables/tcrud_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'AnalyzeHandIcons',
  mixins: [float_mix, tcrud_mix],
  props: {
    hasStarBtn: { type: Boolean, default: true },
    tableMutation: { default: 'api_v2_poker_hand_history_hands' },
    handDetailItem: { default: () => {} },
    idKey: { default: 'id' },
    apiVersion: { default: 'v2' },
    drawerItemId: { default: 'analyze_handV2' },
    detailMutation: { default: 'api_poker_hand_history_hand_detail' },
    getDetailEndpoint: { default: item => `poker/hand-history/hands/${item.public_id}/` },
    hasHotkeys: { default: true },
    isAlwaysEnabled: { default: false },
  },
  emits: ['click:go'],
  data() {
    return {}
  },
  methods: {
    toggleMarked(item) {
      const expected_item = {
        ...item,
        marked: !item.marked,
      }
      this.tcrud_patchItem({
        item,
        patchData: { marked: !item.marked },
        expected_item,
      })
      this.updateDetailItem(expected_item)
    },
    updateDetailItem(item) {
      this.$store.dispatch('globals_drawer', {
        id: this.drawerItemId,
        open: true,
        item,
        maximized: this.$store.getters.globals_drawer.maximized,
      })
    },
    go(num) {
      this.$emit('click:go', num)
      if (!this.hasHotkeys) return
      if (this.noItems) return
      const currIdx = this.tableItems.findIndex(
        i => i[this.idKey] === this.handDetailItem[this.idKey],
      )
      const item =
        this.tableItems[currIdx + num] ||
        (num === 1 ? this.tableItems[0] : this.tableItems[this.tableItems.length - 1])
      this.openHandDetail(item)
    },
    openHandDetail(item) {
      this.$store.dispatch('api_call', {
        endpoint: this.getDetailEndpoint(item),
        mutation: this.detailMutation,
        apiVersion: this.apiVersion,
      })
      this.$store.dispatch('globals_drawer', {
        id: this.drawerItemId,
        open: true,
        item,
        maximized: this.$store.getters.globals_drawer.maximized,
      })
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            hand_detail: item.id,
          },
        })
        .catch(() => {})
    },
  },
  computed: {
    tcrud_conf() {
      return {
        idKey: this.idKey,
        getEndpoint: this.getDetailEndpoint,
        apiVersion: this.apiVersion,
      }
    },
    tcrud_mutation() {
      return this.tableMutation
    },
    tableItems() {
      return this.$store.getters.api_get_data(this.tableMutation)?.results
    },
    noItems() {
      return !this.isAlwaysEnabled && !this.tableItems?.length
    },
    hotkeysPressedBottom() {
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    hotkeysPressedBottom(keys) {
      if (!this.hasHotkeys) return
      if (!keys) return
      const hotkeyActions = {
        go_fw: { keys: ['arrowdown'], fn: () => this.go(1), hasPreventDefault: true },
        go_rw: { keys: ['arrowup'], fn: () => this.go(-1), hasPreventDefault: true },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>

<style lang="scss" scoped>
.aicons {
  --size-icon: 1.5rem;
  position: relative;
  &_item {
    padding: 0.25rem;
    font-size: var(--size-icon);
  }
}
</style>
